import React from 'react';
import { Area, AreaChart, XAxis, YAxis, CartesianGrid } from 'recharts';

import GraphUtility from './graph_utility';

// TODO pull all state values out and then calculate values based on that
// TODO props.swapValues should be set based on threshold evaluation of =/= vs ==

class StateEventGraph extends React.Component {
  constructor(props) {
    super(props);

    const data = this.props.data.map(value => {
      const isTrueValue = value.state === "true";
      const isFalseValue = value.state === "false";
      return {
        timestamp: value.timestamp,
        state: isTrueValue ? 2 : isFalseValue ? -2 : null
      };
    });

    this.state = {
      startTime: data[0].timestamp,
      endTime: data[data.length - 1].timestamp,
      data: data
    }

    // Bind class methods
    this.formatXTicks = this.formatXTicks.bind(this);
    this.formatYTicks = this.formatYTicks.bind(this);
    this.calculateTicks = this.calculateTicks.bind(this);
  } 

  calculateTicks() {
    const data = this.state.data;
    return GraphUtility.calculateTicks(data[0].timestamp, data[data.length - 1].timestamp);
  }

  formatXTicks(tick) {
    const data = this.state.data;
    return GraphUtility.formatTicks(tick, data[0].timestamp, data[data.length - 1].timestamp);
  } 

  formatYTicks(tick) {
    if (tick === 1) {
      return this.props.trueValue ? this.props.trueValue : "";
    } else if (tick === -1) {
      return this.props.falseValue ? this.props.falseValue : "";
    } else {
      return "";
    }
  } 

  gradientOffset() {
    const data = this.state.data;

    const newData = data.slice(0, data.length);
    const dataMax = Math.max(...newData.map((i) => i.state));
    const dataMin = Math.min(...newData.map((i) => i.state));

    if (dataMin === -2 && dataMax === 0) { // all offline, i.e. all red
      return 0;
    } else if (dataMin === 0 && dataMax === 2) { // all online, i.e. all green
      return 1;
    } else if (dataMin === -2 && dataMax === 2) { // offline and online, i.e. mixed color
      return 0.5;
    }
  }

  render() {
    if (this.state.data) {
      const data = this.state.data;
      const firstTime = data[0].timestamp;
      const lastTime = data[data.length - 1].timestamp;
      const offset = this.gradientOffset();

      return (
        <div style={{marginLeft: "-30px"}}>
          <AreaChart width={this.props.width} height={this.props.height} data={data}>
            <CartesianGrid strokeDasharray="0 0"/>

            <XAxis type="number" dataKey="timestamp" scale="time" ticks={this.calculateTicks()} domain={[firstTime, lastTime]} tickFormatter={this.formatXTicks} height={50}/>
            <YAxis type="number" dataKey="state" allowDecimals={false} domain={[-2,2]} tickFormatter={this.formatYTicks} interval={0}/>

            <defs>
              <linearGradient id={`splitColor${this.props.id}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset={offset} stopColor={this.props.swapValues ? (offset === 0.5 ? "red" : "green") : "green"} stopOpacity={1}/>
                <stop offset={offset} stopColor={this.props.swapValues ? (offset === 0.5 ? "green" : "red") : "red"} stopOpacity={1}/>
              </linearGradient>
            </defs>

            <Area type="step" dataKey="state" stroke="none" fill={`url(#splitColor${this.props.id})`} isAnimationActive={false}/>
          </AreaChart>
        </div>

      );
    } else {
      return null;
    }
  } 
} 

export default StateEventGraph;
